import { AuthWebConfig } from '@auspost/auth0-uiim-types';

import { envConfig } from 'config/env-config';
import { apiEndpoint, myPostTrack } from 'config/track-config';
import { EnhancedWindow } from 'models/Window';

type AuthEnvType = 'prod' | 'sandbox' | 'vtest' | 'stest' | 'ptest' | 'dev' | 'playpen' | 'localhost';

const authWebConfigs: AuthWebConfig = {
  audience: apiEndpoint.auth0,
  clientId: envConfig.auth0ClientId,
  env: envConfig.type.toLowerCase() as AuthEnvType,
  redirectUrl: envConfig.url + myPostTrack,
  caller: 'TRACK',
  product: 'MYPOST_CONSUMER',
  channel: 'WEB',
  auth0SessionRequired: true,
  cssoSessionConfig: {
    skipCheck: true,
    skipExchange: true,
    skipRefresh: true,
  },
};

const local = {
  ...authWebConfigs,
  stubDomain: `localhost:4000`,
  stubApiBaseUrl: `http://localhost:4000`,
};

export const auth0Config: AuthWebConfig = process.env.NODE_ENV === 'development' ? local : authWebConfigs;

const eWindow = window as EnhancedWindow;
export const authService = eWindow.__AUSPOST__?.createAuthWebService && eWindow.__AUSPOST__.createAuthWebService();
export default { authService };
